import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'
import { NumberUtils } from '@pbt/pbt-ui-components'

import { useRefundDialog } from '../context/RefundDialogProvider'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'
import styles from './PartialRefundBanner.module.scss'

export const PartialRefundBanner = () => {
  const { t } = useTranslation(['Dialogs', 'Common'])
  const { dialogState } = useRefundDialog()

  if (!dialogState.hasPartialRefund) {
    return null
  }

  return (
    <KibTopLevelAlert
      className={styles.partialRefundBanner}
      heading={t('Dialogs:REFUND_DIALOG_V2.PARTIAL_REFUND_SUCCESS_MESSAGE', {
        amount: NumberUtils.formatMoney(dialogState.partialRefundAmount),
      })}
      severity="success"
    />
  )
}
